import { Component, OnInit, Injector, forwardRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR, ValidatorFn } from '@angular/forms';

import { UtilsService } from '@common/services';
import { InputBase } from '@ui/components/form9/base/input-base';

import { inputDigits9RequiredValidator } from './input-digits9.validators';

@Component({
    selector: 'aa-input-digits9',
    templateUrl: './input-digits9.component.html',
    styleUrls: [
        '../input9.component.scss',
        './input-digits9.component.scss'
    ],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((): typeof InputDigits9Component => InputDigits9Component),
            multi: true,
        }
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InputDigits9Component extends InputBase<string> implements OnInit
{
    private static identifier: number = 0;
    @Input() exactDigits?: number;
    @Input() minDigits?: number;
    @Input() maxDigits?: number;

    constructor (
        injector: Injector,
        controlContainer: ControlContainer
    )
    {
        super(injector, controlContainer);

        this.fieldId = `idInputDigits9-${InputDigits9Component.identifier++}`;
    }

    ngOnInit (): void
    {
        let validators: ValidatorFn | ValidatorFn[];

        if (!UtilsService.isNullOrUndefined(this.exactDigits))
        {
            validators = [inputDigits9RequiredValidator('exact', this.exactDigits, null, this.customMsg)];
        }
        else
        {
            if (!UtilsService.isNullOrUndefined(this.maxDigits))
            {
                validators = [inputDigits9RequiredValidator('minmax', this.minDigits, this.maxDigits, this.customMsg)];
            }
            else
            {
                validators = [inputDigits9RequiredValidator('min', this.minDigits, null, this.customMsg)];
            }
        }

        this.initControl(this.required ? validators : null);
    }
}
